// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
export type WebsiteInitializationSettings = {
  version: "1";
  initializationParameters: string;
  nativeMessagingHostID: string;
  selectedContractVersion: string;
};